// ── Theme definitions ─────────────────────────────────────────────────────────
export const THEMES = {

    neon: {
      name: 'Neon',
      icon: '⚡',
      bg: '#05050f',
      panel: '#08081a',
      card: '#0d0d22',
      border: 'rgba(120,80,255,0.25)',
      border2: 'rgba(120,80,255,0.5)',
      accent: '#7c3aed',
      accent2: '#06b6d4',
      accent3: '#f472b6',
      text: '#e2e8f0',
      muted: '#6b7280',
      progress: 'linear-gradient(90deg,#7c3aed,#06b6d4)',
      jobSelected: 'rgba(124,58,237,0.12)',
      jobSelectedBorder: 'rgba(124,58,237,0.5)',
      tabActive: '#7c3aed',
    },
  
    forest: {
      name: 'Forest',
      icon: '🌿',
      bg: '#071a07',
      panel: '#0a2010',
      card: '#0d2a12',
      border: 'rgba(74,222,128,0.18)',
      border2: 'rgba(74,222,128,0.4)',
      accent: '#4ade80',
      accent2: '#86efac',
      accent3: '#fbbf24',
      text: '#ecfdf5',
      muted: '#6b8f6b',
      progress: 'linear-gradient(90deg,#4ade80,#86efac)',
      jobSelected: 'rgba(74,222,128,0.1)',
      jobSelectedBorder: 'rgba(74,222,128,0.45)',
      tabActive: '#4ade80',
    },
  
    ocean: {
      name: 'Ocean',
      icon: '🌊',
      bg: '#020d1a',
      panel: '#041525',
      card: '#061c2e',
      border: 'rgba(56,189,248,0.18)',
      border2: 'rgba(56,189,248,0.4)',
      accent: '#38bdf8',
      accent2: '#818cf8',
      accent3: '#34d399',
      text: '#e0f2fe',
      muted: '#4b7ea3',
      progress: 'linear-gradient(90deg,#38bdf8,#818cf8)',
      jobSelected: 'rgba(56,189,248,0.08)',
      jobSelectedBorder: 'rgba(56,189,248,0.4)',
      tabActive: '#38bdf8',
    },
  
    fire: {
      name: 'Fire',
      icon: '🔥',
      bg: '#0f0500',
      panel: '#1a0800',
      card: '#210a00',
      border: 'rgba(251,146,60,0.22)',
      border2: 'rgba(251,146,60,0.5)',
      accent: '#fb923c',
      accent2: '#fbbf24',
      accent3: '#f87171',
      text: '#fff7ed',
      muted: '#9a6740',
      progress: 'linear-gradient(90deg,#fb923c,#fbbf24)',
      jobSelected: 'rgba(251,146,60,0.1)',
      jobSelectedBorder: 'rgba(251,146,60,0.45)',
      tabActive: '#fb923c',
    },
  
    classic: {
      name: 'Classic',
      icon: '🎩',
      bg: '#f1f5f9',
      panel: '#ffffff',
      card: '#f8fafc',
      border: 'rgba(0,0,0,0.09)',
      border2: 'rgba(0,0,0,0.18)',
      accent: '#2563eb',
      accent2: '#059669',
      accent3: '#dc2626',
      text: '#0f172a',
      muted: '#64748b',
      progress: 'linear-gradient(90deg,#2563eb,#059669)',
      jobSelected: 'rgba(37,99,235,0.08)',
      jobSelectedBorder: 'rgba(37,99,235,0.4)',
      tabActive: '#2563eb',
    },
  }